module.exports = __webpack_public_path__ + "static/media/who.92e4b425.png";